<template>
  <div>
    <v-menu
      v-bind="{ ...$attrs }"
      offset-y
      :activator="showProfilePicture ? `#${activatorId}` : null"
    >
      <template v-if="!showProfilePicture" #activator="{ on, attrs }">
        <v-btn fab v-bind="{ ...attrs }" v-on="on">
          <v-img contain width="24" height="24" :src="$asset('img/icons/settings.svg')" />
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          link
          class="rounded text-left"
          :data-cy="item.dataCy"
          @click="item.onClick"
        >
          <v-list-item-icon class="ma-0 mr-4 position-relative">
            <v-img
              v-if="item.icon"
              max-width="24"
              contain
              eager
              :src="$asset(`img/icons/${item.icon}`)"
            />
            <component
              :is="item.component"
              v-else-if="item.component"
              :class="`${item.color}--text`"
            />
          </v-list-item-icon>
          <v-list-item-title :class="item.color ? item.color + '--text' : ''">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <ProfilePicture v-if="showProfilePicture" :id="activatorId" size="48" />
  </div>
</template>

<script>
import ProfilePicture from '@/components/Atoms/ProfilePicture';
import DashboardLogout from '@/components/Atoms/Icons/DashboardLogout.vue';

export default {
  name: 'ProfileMenu',
  components: { ProfilePicture, DashboardLogout },
  props: {
    showProfilePicture: {
      type: Boolean,
      default: false
    },
    activatorId: {
      type: String,
      required: false
    }
  },
  computed: {
    menuItems() {
      return [
        {
          title: this.$t('profileSection.menu.profile'),
          icon: 'user.svg',
          onClick: () => {
            this.$router.push(this.$localePath('accountSettings'));
          },
          dataCy: 'clientZoneMyAccountButton'
        },
        {
          title: this.$t('profileSection.menu.logout'),
          component: 'DashboardLogout',
          color: 'error',
          onClick: () => {
            this.logout('login');
          },
          dataCy: 'clientZoneLogoutButton'
        }
      ];
    },
    authorizationType: {
      get() {
        return this.$store.state.profile.authorization.authorizationType;
      },
      set(value) {
        this.$store.commit('profile/authorization/setAuthorizationType', value);
      }
    }
  }
};
</script>
